TYPED_ARRAY_TAG_REQUIRED